import type { ReactNode } from 'react'

export function BookingStepLayout({
    overview,
    children,
    contentClassName
}: {
    overview: ReactNode
    children: ReactNode
    contentClassName?: string
}) {
    return (
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-20 lg:gap-6 w-full">
            {overview}
            <div
                className={`flex min-w-0 flex-col grow gap-10 lg:col-span-3 lg:ml-18 ${contentClassName ?? ''}`.trim()}
            >
                {children}
            </div>
        </div>
    )
}
